import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { LoginComponent } from './features/auth/login/login.component';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        path: 'users',
        canActivate: [AuthGuard],
        data: { roles: ['ADMIN'] },
        loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule),
      },
      {
        path: 'stakeholders',
        loadChildren: () => import('./features/stakeholders/stakeholders.module').then(m => m.StakeholdersModule),
      },
      {
        path: 'gate-passes',
        loadChildren: () => import('./features/gate-passes/gate-passes.module').then(m => m.GatePassesModule),
      },
      {
        path: 'approvals',
        canActivate: [AuthGuard],
        data: { roles: ['ADMIN', 'DEPARTMENT_MANAGER'] },
        loadChildren: () => import('./features/approvals/approvals.module').then(m => m.ApprovalsModule),
      },
      {
        path: 'security',
        canActivate: [AuthGuard],
        data: { roles: ['ADMIN', 'SECURITY_OFFICER'] },
        loadChildren: () => import('./features/security/security.module').then(m => m.SecurityModule),
      },
      {
        path: 'reports',
        loadChildren: () => import('./features/reports/reports.module').then(m => m.ReportsModule),
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
